import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { DragEventType } from './drop-file.directive';

@Component({
    selector: 'aumico-file-upload',
    templateUrl: './file-upload.component.html',
    styleUrls: ['./file-upload.component.scss'],
})
export class AumicoFileUploadComponent implements OnInit {
    @Input()
    public accept = '';

    @Input()
    title = '';

    @Input()
    instructionTextKey = 'aumico_core_file_upload_instruction_text';

    @Input()
    instructionLabelKey = 'aumico_core_file_upload_instruction_label';

    @Input()
    extensionErrorKey = 'aumico_core_file_upload_extension_error';

    @Input()
    public tint = true;
    @Input()
    currentFileName: string;

    fileInside = false;
    fileExtensionError = false;

    @Output()
    fileChange = new EventEmitter<File>();

    @ViewChild('fileInput', { static: false })
    fileInput: ElementRef<HTMLInputElement>;

    public get currentFile(): File {
        return this._currentFile;
    }
    public set currentFile(value: File) {
        this._currentFile = value;
        this.currentFileName = value ? value.name : null;
    }

    // Do not access directly
    // tslint:disable-next-line: variable-name
    private _currentFile: File;

    constructor() {}

    ngOnInit() {}

    onFileChange(event: Event) {
        // upon file change, we clear the current file
        this.currentFile = null;
        const target = event.target as HTMLInputElement;
        const files = target.files;
        const fileExtension = files[0].name.split('.').pop();
        // Only xlsx and xls are supported for now
        const acceptedExtensions = this.accept.split(',');
        if (!acceptedExtensions.includes('.' + fileExtension)) {
            this.fileExtensionError = true;
        } else {
            if (files.length > 0) {
                this.currentFile = files[0];
                this.fileChange.emit(this.currentFile);
            }
        }
    }

    onClick(event: MouseEvent) {
        this.fileInput.nativeElement.click();
    }

    onBinClicked(event) {
        this.fileInput.nativeElement.files = null;
        this.fileInput.nativeElement.value = null;
        this.currentFile = null;
        this.currentFileName = null;
        this.fileChange.emit(this.currentFile);
    }

    onStateEvent(event: DragEventType) {
        if (event === 'dragleave') {
            this.fileInside = false;
        } else {
            this.fileInside = true;
        }
    }
    onFileDropped(event: File) {
        this.currentFile = event;
        this.fileChange.emit(this.currentFile);
    }
}
